import { Box, Container, Typography } from "@mui/material";
import { HomeBg } from "assets/index";
import { useNavigate } from "react-router-dom";
import theme, { responsiveFontSize } from "themes/Theme";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const handleScroll = () => {
    const section = document.getElementById("cookies-and-tracking");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.pageHeroBg}>
        <center>
          <Typography sx={styles.pageTitle}>Privacy Policy</Typography>
        </center>
      </Box>

      <Container
        sx={{
          borderRadius: 3,
          boxShadow: `rgba(125, 125, 125, 0.4) 0px 2px 9px 1px, rgba(200, 200, 200, 0.2) 0px 2px 9px 1px`,
          backgroundColor: "rgb(255, 255, 255)",
          p: 3,
          my: 3,
        }}
      >
        <Typography sx={styles.tabHeadingText}>1. Introduction</Typography>
        <Typography sx={styles.tabDescText}>
          "Welcome to the Carbon Plant Exchange website (the "Site"). Carbon
          Plant LTD ("we," "us," or "our"), located at The Engine House,
          Alexandra Road, Castletown, Isle of Man, IM9 1TG, is the data
          controller responsible for the processing of your personal data. We
          are committed to protecting your privacy and ensuring the security of
          your personal information. This Privacy Policy outlines how we
          collect, use, and share information when you use our Site and related
          services, which facilitate the exchange of carbon credits and
          associated environmental attributes.Our Services involve collecting,
          storing, and processing data related to carbon removal projects,
          methodologies, environmental attributes, user account information, and
          transaction records. We prioritize data minimization, collecting only
          the information necessary for the purposes outlined in this policy.We
          may update this Privacy Policy periodically. We will notify you of any
          material changes by posting the updated policy on our Site and, where
          appropriate, via email. We encourage you to review this policy
          regularly.
        </Typography>
        <Typography sx={styles.tabHeadingText}>
          2. Information We Collect Registration and Identification Information
        </Typography>
        <Typography sx={styles.tabDescText}>
          Name, company name, contact details (email, phone, address). KYC/AML
          information (identification documents, proof of address, etc.) as
          legally required. Business registration details, tax identification
          numbers. Transaction Information: Records of carbon credit
          transactions, including buy/sell orders, transaction history, and
          related data. Financial information related to transactions (payment
          details, bank account information). Blockchain transaction
          information, including wallet addresses. Carbon Project Data: Project
          details (location, methodology, technology). Verification and
          certification data. Monitoring, reporting, and verification (MRV)
          data. Environmental attributes (e.g., co-benefits, additionality).
          Project documentation, including sustainability reports. Website Usage
          Data: IP address, browser type, device information. Cookies and
          tracking technologies{" "}
          <span
            onClick={handleScroll}
            style={{ cursor: "pointer", color: theme.palette.primary.light }}
          >
            (see section 7)
          </span>
          . Log files, website activity, and analytics. User interaction data,
          such as page views, and time spent on pages. Communication Data:
          Records of communications with us, including emails, chat logs, and
          support tickets.
        </Typography>
        <Typography sx={styles.tabHeadingText}>3. How We Use Your</Typography>
        <Typography sx={styles.tabDescText}>
          Information Platform Operation: To facilitate carbon credit
          transactions and manage user accounts. To provide customer support and
          respond to inquiries. To ensure the security and integrity of the
          platform. To perform contractual obligations with users. Compliance
          and Legal Obligations: To comply with KYC/AML regulations and other
          legal requirements. To prevent fraud and illegal activities. To
          provide data to regulators when legally obliged to do so. To comply
          with accounting and tax regulations. Communication: To send
          transactional emails and updates. To provide information about
          platform updates and services. Marketing purposes, only if explicit
          consent is received. Data Analysis and Improvement: To analyse website
          usage and improve platform functionality. To generate reports and
          insights related to carbon credit markets. To support scientific
          research and development in the field of carbon removal, in an
          anonymized or aggregated format. Legal Basis for Processing: We
          process your registration and transaction information to perform our
          contract with you. We process KYC/AML information to comply with our
          legal obligations. We process your email address for marketing
          purposes with your consent. We process website usage data based on our
          legitimate interest to improve our service.
        </Typography>
        <Typography sx={styles.tabHeadingText}>4. Sharing Your</Typography>
        <Typography sx={styles.tabDescText}>
          Information Third-Party Service Providers: Payment processors, KYC/AML
          verification services, and other essential service providers.
          Blockchain analysis companies, for transaction monitoring. Carbon
          credit registries and verification bodies. Regulatory Authorities:
          When required by law or to comply with legal obligations. Business
          Partners: With partners involved in carbon project verification or
          related services, under strict confidentiality agreements. Legal
          Requirements: When required by law, such as to respond to a subpoena
          or court order. International Data Transfers: Where we transfer data
          outside the Isle of Man, or the UK, we implement appropriate
          safeguards, such as Standard Contractual Clauses (SCCs) or other
          legally recognized mechanisms, to ensure an adequate level of data
          protection. We will limit jurisdictions to those with adequate levels
          of data protection.
        </Typography>
        <Typography sx={styles.tabHeadingText}>5. Data Security</Typography>
        <Typography sx={styles.tabDescText}>
          We implement robust security measures to protect your personal
          information, access controls, regular security assessments, and
          penetration testing. We also have an incident response plan in place.
          We retain your data only for as long as necessary for the purposes
          outlined in this policy, or as required by law. Specific retention
          periods will be applied, such as retaining account information for as
          long as the account is active, and transaction records for a set
          number of years to comply with financial regulations. If a data breach
          occurs, we will notify affected users and relevant authorities in
          accordance with applicable data protection laws.
        </Typography>
        <Typography sx={styles.tabHeadingText}>6. Your Rights</Typography>
        <Typography sx={styles.tabDescText}>
          <strong>
            You have the following rights regarding your personal information:
          </strong>
          <br />
          Access, rectification, erasure, restriction of processing, data
          portability, and the right to object. The right to withdraw consent
          (where applicable). The right to lodge a complaint with the Isle of
          Man Information Commissioner. To exercise these rights, please contact
          us at{" "}
          <span
            style={{
              cursor: "pointer",
              color: theme.palette.primary.light,
            }}
            onClick={() => {
              navigate("/contact-us");
            }}
          >
            [Contact Us]
          </span>
          . We will respond to all requests within the legally mandated time
          frame.
        </Typography>
        <Typography sx={styles.tabHeadingText} id={"cookies-and-tracking"}>
          7. Cookies and Tracking Technologies
        </Typography>
        <Typography sx={styles.tabDescText}>
          We use cookies and similar technologies to enhance your browsing
          experience and collect website usage data. We use essential,
          performance, functional, and marketing cookies. You can manage your
          cookie preferences through your browser settings. For more
          information, please refer to our Cookie Policy, available on our
          website. Clearly list the third-party cookies used, and their
          function.
        </Typography>
        <Typography sx={styles.tabHeadingText}>
          8. Changes to This Privacy Policy
        </Typography>
        <Typography sx={styles.tabDescText}>
          We may update this Privacy Policy from time to time. We will notify
          you of any material changes by posting the updated policy on our Site
          and, where appropriate, via email.
        </Typography>
        <Typography sx={styles.tabHeadingText}>
          9. Contact Information
        </Typography>
        <Typography sx={styles.tabDescText}>
          If you have any questions or concerns about this Privacy Policy,
          please contact us at:{" "}
          <span
            style={{
              cursor: "pointer",
              color: theme.palette.primary.light,
            }}
            onClick={() => {
              navigate("/contact-us");
            }}
          >
            [Contact Us]
          </span>
          .
        </Typography>
      </Container>
    </Box>
  );
};
export default PrivacyPolicyPage;
const styles = {
  container: {
    minHeight: "100vh",
  },
  pageHeroBg: {
    backgroundImage: `url(${HomeBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderBottomLeftRadius: "50px",
    borderBottomRightRadius: "50px",
    width: "100%",
    padding: "1em",
  },
  pageTitle: {
    py: 15,
    fontSize: responsiveFontSize(75),
    fontWeight: 400,
    color: theme.palette.custom.white,
  },
  tabHeadingText: {
    fontSize: responsiveFontSize(22),
    color: theme.palette.text.primary,
    fontWeight: 400,
    marginTop: 2,
  },
  tabDescText: {
    fontSize: responsiveFontSize(15),
    color: theme.palette.text.primary,
    fontWeight: 400,
    ml: 3,
  },
};
